import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';
import { getTimezoneTextById } from '../../common/utils/date.helpers';
import { IconNames } from '../../common/constants/icon-names';

@Component({
  selector: 'ui-hub-timezone-message',
  imports: [CommonModule, TranslateModule, SvgIconComponent],
  templateUrl: './hub-timezone-message.component.html',
  styleUrls: ['./hub-timezone-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HubTimezoneMessageComponent {
  @Input() timezoneId: string;

  get timezoneText(): string {
    return getTimezoneTextById(this.timezoneId);
  }

  iconNames = IconNames;
}
